// extracted by mini-css-extract-plugin
export var label = "index-module--label--ub+J3";
export var root = "index-module--root--5pQWN";